module.exports = __webpack_public_path__ + "static/media/lotto-landing-copy-only-version.20f0fc77.png";